import { C_ACTION } from '../constans';

let new_state;
let index;

export const providers = (state = [], action) => {
  switch (action.type) {
    case C_ACTION.ADD_PROVIDERS: {
      return [...action.data];
    }
    case C_ACTION.ADD_ONE_PROVIDER: {
      return [...state, action.data];
    }
    case C_ACTION.CHANGE_PROVIDER: {
      console.log(action)
      new_state = [...state];
      index = new_state.findIndex(p => p.id === action.id);
      new_state.splice(index, 1, action.data);
      return [...new_state];
    }

    case C_ACTION.DELETE_PROVIDER: {
      new_state = [...state];
      index = new_state.findIndex(p => p.id === action.id);
      new_state.splice(index, 1);
      return [...new_state];
    }
    default:
      return state;
  }
};
